import Vue from "vue";
import Vuex from "vuex";
import user from "./user/index";
import alert from "./alert/index";
import profile from "./profile/index";
import changePassword from "./change-password/index";
import deleteAccount from "./delete-account/index";
import isamError from "./isam-error/index";
Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    user,
    alert,
    profile,
    changePassword,
    deleteAccount,
    isamError
  },
});
